package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html.{a, className, href, onClick, target}

/** Displays a link */
@react object Link {
	/**
	 * @param caption
	 * @param url If non-empty, the link is an actual hyperlink
	 * @param newTab Only used if url is non-empty
	 * @param onClick Called when the link is clicked
	 */
	case class Props
	(
		caption: String,
		url: Option[String] = None,
		newTab: Boolean = true,
		onClick: () => Unit = () => Unit
	)

	val component = FunctionalComponent[Props] { props =>
		a(
			className := defaultLinkClass,
			onClick := props.onClick,
			href := props.url,
			target := props.url.map(_ => if (props.newTab) "_blank" else "_self")
		)(
			props.caption
		)
	}

	private val defaultLinkClass = "efactory-link"
}
